/* eslint-disable react/no-array-index-key */
import { useEffect, useRef, useState } from 'react';
import { ItemsContainer } from '../../timeline.styled';
import { IconButtonVariants } from '../../../../../../../components/Common/Buttons/icon-button/icon-button.enums';
import { PerfectButtonHoverVariants } from '../../../../../../../components/Common/Buttons/perfect-base-button/perfect-base-button.enums';
import { CompanySizeTierEnum } from '../../../../../../../enums/company-size-tier.enum';
import {
  Container,
  ExperienceTagsWrapper,
  SkillTagIcon,
  SeeMoreButton,
  SeeMoreButtonIcon,
  ExperienceTag,
  IndustryTagIcon,
  SmallCompanyIcon,
  MediumCompanyIcon,
  LargeCompanyIcon,
  VeryLargeCompanyIcon,
} from './experience-item-tags.styled';
import { ExperienceTagsProps } from './experience-item-tags';
import { ExperienceTagType } from './experience-item-tags.enums';

const MINIMIZED_CONTAINER_HEIGHT_PX = 30;

const COMPANY_SIZE_ICON_MAP = {
  [CompanySizeTierEnum.Small]: SmallCompanyIcon,
  [CompanySizeTierEnum.Medium]: MediumCompanyIcon,
  [CompanySizeTierEnum.Large]: LargeCompanyIcon,
  [CompanySizeTierEnum.VeryLarge]: VeryLargeCompanyIcon,
};

function ExperienceTags({ tags, viewChangeHandler }: ExperienceTagsProps): JSX.Element {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef?.current) {
      setIsExpanded(containerRef?.current?.clientHeight <= MINIMIZED_CONTAINER_HEIGHT_PX);
    }
  }, []);

  const renderTags = () => tags.map(((tag, index) => {
    let Icon;

    switch (tag.type) {
      case ExperienceTagType.Skill:
        Icon = SkillTagIcon;
        break;
      case ExperienceTagType.Industry:
        Icon = IndustryTagIcon;
        break;
      case ExperienceTagType.CompanySize:
        Icon = tag.subtype ? COMPANY_SIZE_ICON_MAP[tag.subtype as CompanySizeTierEnum] : undefined;
        break;
      default:
        return null;
    }

    return (
      <ExperienceTag
        key={ `${tag.type}_${tag.text}_${index}` }
        text={ tag.text }
        askedByUser={ tag.askedByUser }
        Icon={ Icon }
        tagInfo={ tag.tagInfo }
      />
    );
  })).filter(Boolean);

  const onSeeMoreButtonClick = () => {
    viewChangeHandler?.();
    setIsExpanded(true);
  };

  return (
    <Container>
      <ItemsContainer
        minimized={ !isExpanded }
        minimizedHeight={ MINIMIZED_CONTAINER_HEIGHT_PX }
        fullHeight={ containerRef?.current?.clientHeight }
      >
        <ExperienceTagsWrapper ref={ containerRef }>
          {renderTags()}
        </ExperienceTagsWrapper>
      </ItemsContainer>
      { !isExpanded && (
        <SeeMoreButton
          type="button"
          variant={ IconButtonVariants.Fill }
          hoverVariant={ PerfectButtonHoverVariants.Grow }
          onClick={ onSeeMoreButtonClick }
          StartIcon={ SeeMoreButtonIcon }
        />
      ) }
    </Container>
  );
}

export default ExperienceTags;
